import { createApi } from "@reduxjs/toolkit/query/react";
import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { customFetchBase } from ".";

const dashboardApi = createApi({
  reducerPath: REDUCER_PATHS.DASHBOARD,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    getDashboardStatics: builder.query({
      query: (data) => ({
        url: `${apiConfig.DASHBOARD_STATICS}?timeFrameType=${data?.timeFrameType}`,
        method: "GET",
      }),
      providesTags: ["getDashboardStaticsData"],
    }),
    getDashboardBarGraph: builder.query({
      query: (data) => ({
        url: `${apiConfig.DASHBOARD_BAR_GRAPH}?timeFrameType=${data?.timeFrameType}&masterName=${data?.masterName}`,
        method: "GET",
      }),
      providesTags: ["getDashboardStaticsData"],
    }),
    getDownloadReport: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.DASHBOARD_DOWNLOAD_REPORT}?timeFrameType=${data?.timeFrameType}&masterName=${data?.masterName}`,
        method: "GET",
      }),
      providesTags: ["getDashboardStaticsData"],
    }),
    getDashboardLineGraph: builder.query({
      query: (data) => ({
        url: `${apiConfig.DASHBOARD_LINE_GRAPH}?timeFrameType=${data?.timeFrameType}&time=${data?.time}&planType=${data?.planType}`,
        method: "GET",
      }),
      providesTags: ["getDashboardStaticsData"],
    }),
    getGraphData: builder.query({
      query: (data) => ({
        url: `/admin/dashboard/line-graph?startDate=${data?.startDate}&endDate=${data?.endDate}&type=${data?.type}&status=${data?.status}&filter=${data?.filter}`,
        method: "GET",
      }),
      providesTags: ["getGraphData"],
    }),
    getPatientGraphData: builder.query({
      query: (data) => ({
        url: `/admin/dashboard/line-graph-patient?startDate=${data?.startDate}&endDate=${data?.endDate}&type=${data?.type}`,
        method: "GET",
      }),
      providesTags: ["getGraphData"],
    }),
    getNotifications: builder.query({
      query: (data) => ({
        url: `/admin/notifications/listing?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data?.searchText}`,
        method: "GET",
      }),
      providesTags: ["getNotifications"],
    }),
    updateNotificationStatus: builder.mutation({
      query: (data) => ({
        url: "/admin/notifications",
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["getNotifications"],
      // transformResponse: (resp) => transformResponseHandler(resp),
    }),
    dashboardStatics: builder.query({
      //  `/admin/dashboard/counts?userEndDate=${data?.userEndDate}&userStartDate=${data?.userStartDate}`
      query: (data) => ({
        url: `/admin/dashboard/counts`,
        method: "GET",
      }),
    }),
    patientStatics: builder.query({
      query: (data) => ({
        url: `/admin/dashboard/counts?patientStartDate=${data?.patientStartDate}&patientEndDate=${data?.patientEndDate}`,
        method: "GET",
      }),
    }),
    woundStatics: builder.query({
      // /admin/dashboard/counts?woundStartDate=${data?.woundStartDate}&woundEndDate=${data?.woundEndDate}
      query: (data) => ({
        url: `/admin/dashboard/counts`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetDashboardStaticsQuery,
  useLazyGetDashboardBarGraphQuery,
  useGetDownloadReportMutation,
  useLazyGetDashboardLineGraphQuery,
  useLazyGetGraphDataQuery,
  useLazyGetNotificationsQuery,
  useUpdateNotificationStatusMutation,
  useLazyDashboardStaticsQuery,
  useLazyPatientStaticsQuery,
  useLazyWoundStaticsQuery,
  useLazyGetPatientGraphDataQuery,
} = dashboardApi;

export default dashboardApi;
